import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Andreas Gohr
 * id 20BCC8DA-F055-46B0-9C27-68791E3BA80E
 * name format-header-increase
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-header-increase.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatHeaderIncreaseIcon = createSvgIcon(<><path d="M4,4H6V10H10V4H12V18H10V12H6V18H4V4M14.59,7.41L18.17,11L14.59,14.59L16,16L21,11L16,6L14.59,7.41Z" /></>, 'FormatHeaderIncreaseIcon');
export default FormatHeaderIncreaseIcon